"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpacePathType = exports.Navigation = void 0;
var Navigation;
(function (Navigation) {
    Navigation[Navigation["HOME"] = 0] = "HOME";
    Navigation[Navigation["LOGIN"] = 1] = "LOGIN";
    Navigation[Navigation["APPLY_LOGOUT"] = 2] = "APPLY_LOGOUT";
    Navigation[Navigation["REGISTER"] = 3] = "REGISTER";
    Navigation[Navigation["RESET_PWD"] = 4] = "RESET_PWD";
    Navigation[Navigation["CREATE_SPACE"] = 5] = "CREATE_SPACE";
    Navigation[Navigation["WORKBENCH"] = 6] = "WORKBENCH";
    Navigation[Navigation["SPACE"] = 7] = "SPACE";
    Navigation[Navigation["SPACE_MANAGE"] = 8] = "SPACE_MANAGE";
    Navigation[Navigation["NOT_FOUND"] = 9] = "NOT_FOUND";
    Navigation[Navigation["INVITE"] = 10] = "INVITE";
    Navigation[Navigation["SET_PASSWORD"] = 11] = "SET_PASSWORD";
    Navigation[Navigation["SHARE_FAIL"] = 12] = "SHARE_FAIL";
    Navigation[Navigation["SETTING_NICKNAME"] = 13] = "SETTING_NICKNAME";
    Navigation[Navigation["SHARE_SPACE"] = 14] = "SHARE_SPACE";
    Navigation[Navigation["NO_SUPPORT"] = 15] = "NO_SUPPORT";
    Navigation[Navigation["TEMPLATE"] = 16] = "TEMPLATE";
    Navigation[Navigation["TRASH"] = 17] = "TRASH";
    Navigation[Navigation["IMPROVING_INFO"] = 18] = "IMPROVING_INFO";
    Navigation[Navigation["INVITATION_VALIDATION"] = 19] = "INVITATION_VALIDATION";
    Navigation[Navigation["MEMBER_DETAIL"] = 20] = "MEMBER_DETAIL";
    Navigation[Navigation["FEISHU"] = 21] = "FEISHU";
    Navigation[Navigation["DINGTALK"] = 22] = "DINGTALK";
    Navigation[Navigation["WECOM"] = 23] = "WECOM";
    Navigation[Navigation["WECOM_SHOP_CALLBACK"] = 24] = "WECOM_SHOP_CALLBACK";
    Navigation[Navigation["EMBED_SPACE"] = 25] = "EMBED_SPACE";
})(Navigation = exports.Navigation || (exports.Navigation = {}));
var SpacePathType;
(function (SpacePathType) {
    SpacePathType["SAPCE_OVERVIEW"] = "overview";
    SpacePathType["MANAGE_WORKBENCH"] = "workbench";
    SpacePathType["MANAGE_MEMBER"] = "managemember";
    SpacePathType["MAIN_ADMIN"] = "mainadmin";
    SpacePathType["SUB_ADMIN"] = "subadmin";
    SpacePathType["MEMBER"] = "member";
    SpacePathType["MARKETING"] = "marketing";
})(SpacePathType = exports.SpacePathType || (exports.SpacePathType = {}));
//# sourceMappingURL=router.js.map